module.exports = __webpack_public_path__ + "static/media/title_2.44.0598f69d.svg";